<div class="col-md-12 clear-padding">  
  <span class="newslistitem-header dark-blue-color" (click)="ViewMoreInfo()">{{NewsItem.Title}}</span>
  <br />
  <span class="newslistitem-content" [innerHtml]="NewsItem.Description"></span>
  <br />
  <span class="blue clickable" (click)="ViewMoreInfo()">View more info</span>
</div>
